import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateFormatter',
    standalone: false
})
export class DateFormatterPipe implements PipeTransform {
  transform(value: Date | string): string {
    if (!value) return ''; // Handle null/undefined inputs

    const date = new Date(value);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    if (date.toDateString() === today.toDateString()) {
      return 'Today at ' + date.toLocaleTimeString([], { hour: '2-digit', minute:'2-digit', second: '2-digit' });
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday at ' + date.toLocaleTimeString([], { hour: '2-digit', minute:'2-digit', second: '2-digit' });
    } else {
      return date.toLocaleDateString();
    }
  }
}